import { render } from "./featured-category-small-inner.vue?vue&type=template&id=7bb68eec"
import script from "./featured-category-small-inner.vue?vue&type=script&lang=js"
export * from "./featured-category-small-inner.vue?vue&type=script&lang=js"

import "./featured-category-small-inner.vue?vue&type=style&index=0&id=7bb68eec&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__